import type React from "react";
import BoxHeading from "./BoxHeading.tsx";

export default function Box({
	children,
	icon,
	iconTitle,
	noPadding = false,
	backgroundImage,
	className = "",
	innerClassName = "",
	style,
	...props
}: React.HTMLAttributes<HTMLDivElement> &
	React.PropsWithChildren<{
		style?: React.CSSProperties;
		className?: string;
		innerClassName?: string;
		icon?: React.ReactNode;
		iconTitle?: string;
		backgroundImage?: string;
		noPadding?: boolean;
	}>) {
	return (
		<section
			style={style}
			className={`relative rounded-box overflow-hidden bg-agate-900/60 ${!noPadding ? "py-4 px-6" : ""} ${className}`}
			{...props}
		>
			{backgroundImage && (
				<img
					src={backgroundImage}
					className="absolute top-0 left-0 w-full h-full object-cover z-0 rounded-box filter brightness-50"
					alt="Box Background"
				/>
			)}
			{icon && iconTitle && (
				<BoxHeading className="relative z-10" icon={icon} title={iconTitle} />
			)}
			<div className={`block relative z-10 ${innerClassName}`}>{children}</div>
		</section>
	);
}
